const config = {
    apiUrl: process.env.REACT_APP_MOBILITY_API_URL || `https://academica.hr/api`,
    get tenant () { 
        return process.env.REACT_APP_TENANT || 'krizevci'
    }
}

export default config;